import { BookOpen, BookMarked, FileText, PenTool, type LucideIcon } from 'lucide-react';
import { NAV_PATHS } from '../constants/navigation';

export type SectionNavItem = {
  path: (typeof NAV_PATHS)[keyof typeof NAV_PATHS];
  label: string;
  icon: LucideIcon;
};

export const SECTION_NAV_ITEMS: SectionNavItem[] = [
  { path: NAV_PATHS.GRAMMAR, label: 'Grammar', icon: BookOpen },
  { path: NAV_PATHS.VOCABULARY, label: 'Vocabulary', icon: BookMarked },
  { path: NAV_PATHS.READING, label: 'Reading', icon: FileText },
  { path: NAV_PATHS.WRITING, label: 'Writing', icon: PenTool },
];
